let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b25HD")).then(() => parcelRequire('gE9ms'));